import { Card, Col, message } from "antd";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import Feedback from "./Utilities/Feedback";
import * as userReducer from "./Redux/User/reducer";
import { LoadingOutlined } from "@ant-design/icons";
import { useState } from "react";
import constants from "./Redux/constants";
import { useHistory } from "react-router-dom";

const EmailVerification = (props) => {
  const history = useHistory();
  const [verifying, setVerifying] = useState(false);
  useEffect(() => {
    const verifyEmail = async (token) => {
      const { responseStatus, accountType } = await props.verifyEmail(token);
      console.log(accountType);
      if (responseStatus === constants.status.notFound) {
        setVerifying(false);
        message.warn("You are already verified!", 5);
      } else if (responseStatus === constants.status.success) {
        setVerifying(true);
        setTimeout(() => {
          accountType === constants.roles.client
            ? history.push("/client/home")
            : history.push("/consultant/home");
        }, 2500);
      }
    };
    verifyEmail(props.token);
  }, [props, history]);
  return (
    <Col xs={{ span: 24 }}>
      <Card style={{ width: "100%" }}>
        {verifying ? (
          <Feedback
            title="Verified Successfully"
            subTitle="Your account has been verified"
            status="success"
          ></Feedback>
        ) : (
          <Feedback
            status="info"
            title="Please wait while verifying"
            subTitle="It will take few seconds for verification"
            icon={<LoadingOutlined />}
          ></Feedback>
        )}
      </Card>
    </Col>
  );
};

const mapStateToProps = (state) => ({
  isVerified: state.userStore.isVerified,
});

const mapDispatchToProps = (dispatch) => {
  return {
    verifyEmail: (token) => dispatch(userReducer.verifyEmail(token)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailVerification);
